export default "__VITE_ASSET__Z1P3L9qv__"